module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-nav-left"
  }, [_c('div', {
    staticClass: "kp-modular-name"
  }, [_c('input', {
    staticClass: "kp-modular-name-txt",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "change": function($event) {
        return _vm.boxSetName($event)
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('general.labels.box_name')))])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-453e345e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/topbar/Name.vue
 ** module id = 813
 ** module chunks = 1
 **/